/** Gateway heartbeat offline threshold (seconds) — must match backend when deployed */
export const GATEWAY_OFFLINE_THRESHOLD_SEC = 120;

/** How often to poll gateway status API (ms) */
export const GATEWAY_STATUS_POLL_MS = 30000;

export const GATEWAY_STATUS = {
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE',
  UNKNOWN: 'UNKNOWN',
};
